import React from 'react';
import cn from 'classnames';
import styles from './label.module.scss';
import { TOKENS } from '@creditflowresearch/uilib/constants/tokens';

export interface IProps {
  /**
   * The content to be displayed inside the label
   */
  children: React.ReactNode,
  /**
   * Additional CSS class for custom styling
   */
  className?: string,
  /**
   * Background color of the label
   */
  backgroundColor?: string,
  /**
   * Text color of the label
   */
  textColor?: string,
  /**
   * Font size of the label
   */
  fontSize?: string | number,
  /**
   * Whether the label text should be bold
   */
  isBold?: boolean,
}

function Label({
  className,
  backgroundColor = TOKENS.surface.neutralPage,
  textColor = TOKENS.text.primaryOnColor,
  fontSize = 12,
  isBold = false,
  children,
}: IProps) {
  const classNames = cn(styles.label, {
    [styles.isBold]: isBold,
  }, className);

  if (!fontSize.toString().includes('px')) {
    fontSize += 'px';
  }

  return (
    <div
      className={ classNames }
      data-test="badgeLabel"
      style={ {
        backgroundColor,
        color: textColor,
        fontSize,
      } }
    >
      { children }
    </div>
  );
}

export default Label;
